module.exports = __webpack_public_path__ + "6fa468feed996b1a9be4059e82c74779.svg";